import Card from "@/components/Card.vue";
import CrmAverageDurationByOutcome from "@/components/stats/widgets/CrmAverageDurationByOutcome.vue";
import CrmAverageDurationView from "@/components/stats/widgets/CrmAverageDurationView.vue";
import CrmEstimateSalesByPeriod from "@/components/stats/widgets/CrmEstimateSalesByPeriod.vue";
import CrmEstimateStatusTurnover from "@/components/stats/widgets/CrmEstimateStatusTurnover.vue";
import CrmEstimateStatusTurnoverPercentage from "@/components/stats/widgets/CrmEstimateStatusTurnoverPercentage.vue";
import CrmGetAveragePaymentDelay from "@/components/stats/widgets/CrmGetAveragePaymentDelay.vue";
import CrmGetInvoiceAndAdvanceCountStatistic from "@/components/stats/widgets/CrmGetInvoiceAndAdvanceCountStatistic.vue";
import CrmGetOpportunitiesConversionRate from "@/components/stats/widgets/CrmGetOpportunitiesConversionRate.vue";
import CrmGetTopActivitiesForWonOpportunities from "@/components/stats/widgets/CrmGetTopActivitiesForWonOpportunities.vue";
import CrmGetTotalAppointmentByStatus from "@/components/stats/widgets/CrmGetTotalAppointmentByStatus.vue";
import CrmInvoiceStatByStatus from "@/components/stats/widgets/CrmInvoiceStatByStatus.vue";
import CrmInvoiceTurnOver from "@/components/stats/widgets/CrmInvoiceTurnOver.vue";
import CrmOpportunitiesByStage from "@/components/stats/widgets/CrmOpportunitiesByStage.vue";
import CrmOpportunitiesTotalByStatus from "@/components/stats/widgets/CrmOpportunitiesTotalByStatus.vue";
import CrmSalesByPeriods from "@/components/stats/widgets/CrmSalesByPeriods.vue";
import CrmTopContacts from "@/components/stats/widgets/CrmTopContacts.vue";
import CrmTopCustomer from "@/components/stats/widgets/CrmTopCustomer.vue";
import CrmTopOpportunitiesEstimateStat from "@/components/stats/widgets/CrmTopOpportunitiesEstimateStat.vue";
import CrmTopOpportunitiesLostReason from "@/components/stats/widgets/CrmTopOpportunitiesLostReason.vue";
import CrmTopProduct from "@/components/stats/widgets/CrmTopProduct.vue";
import CrmTopProspects from "@/components/stats/widgets/CrmTopProspects.vue";
import CrmTopTotalAppointmentPerCreator from "@/components/stats/widgets/CrmTopTotalAppointmentPerCreator.vue";
import ProjectUserPerformance from "@/components/stats/widgets/ProjectUserPerformance.vue";
import { markRaw } from "vue";


export const widgetLibraries = markRaw({ 
    WidgetCard: Card,
    CrmAverageDuration: CrmAverageDurationView,
    CrmAverageDurationByOutcome: CrmAverageDurationByOutcome,
    CrmEstimateSalesByPeriod: CrmEstimateSalesByPeriod,
    CrmEstimateStatusTurnover: CrmEstimateStatusTurnover,
    CrmEstimateStatusTurnoverPercentage: CrmEstimateStatusTurnoverPercentage,
    CrmGetAveragePaymentDelay: CrmGetAveragePaymentDelay,
    CrmGetInvoiceAndAdvanceCountStatistic: CrmGetInvoiceAndAdvanceCountStatistic,
    CrmGetOpportunitiesConversionRate: CrmGetOpportunitiesConversionRate,    
    CrmGetTopActivitiesForWonOpportunities: CrmGetTopActivitiesForWonOpportunities,
    CrmGetTotalAppointmentByStatus: CrmGetTotalAppointmentByStatus,
    CrmInvoiceStatByStatus: CrmInvoiceStatByStatus,
    CrmInvoiceTurnOver: CrmInvoiceTurnOver,
    CrmOpportunitiesByStage: CrmOpportunitiesByStage,   
    CrmOpportunitiesTotalByStatus: CrmOpportunitiesTotalByStatus,
    CrmSalesByPeriods: CrmSalesByPeriods,
    CrmTopContacts: CrmTopContacts,
    CrmTopCustomer: CrmTopCustomer,
    CrmTopOpportunitiesEstimateStat: CrmTopOpportunitiesEstimateStat,  
    CrmTopOpportunitiesLostReason: CrmTopOpportunitiesLostReason, 
    CrmTopProduct: CrmTopProduct,
    CrmTopProspects: CrmTopProspects,
    CrmTopTotalAppointmentPerCreator: CrmTopTotalAppointmentPerCreator,
    ProjectUserPerformance: ProjectUserPerformance,
  })